import { createFileRoute } from "@tanstack/react-router";
import { buildSeoMeta } from "@/lib/seo";

export const Route = createFileRoute("/legal/privacy")({
  head: () => buildSeoMeta({
    title: "Privacy Policy — RanchPlanner",
    description: "Privacy Policy for RanchPlanner by 1uplift LLC.",
    path: "/legal/privacy",
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="min-h-screen py-16 px-4">
      <div className="max-w-2xl mx-auto prose prose-neutral dark:prose-invert">
        <h1>Privacy Policy</h1>
        <p className="text-muted-foreground">Last updated: May 12, 2026</p>

        <h2>1. Information We Collect</h2>
        <p>Information you enter into RanchPlanner may be retained in an anonymized and aggregated form so we can improve recommendations over time. The only exception is your email address, which we store when you choose to save or share a plan (or otherwise contact us) for the sole purpose of delivering that email — it is kept separately and is not linked back to the rest of your activity on the site.</p>

        <h2>2. How We Use Information</h2>
        <p>Anonymous quiz data is used to generate recommendations in your session and, in aggregate, to understand which kinds of plans are popular. Email addresses are used only to enable plan saving, sharing, and follow-up on submitted events or feedback. We do not sell or share personal information with third parties for marketing purposes.</p>

        <h2>3. Cookies & Analytics</h2>
        <p>We use browser local storage to remember your theme preference and session data. We use analytics cookies to understand how visitors interact with the site, including page views, feature usage, and engagement metrics. These analytics help us improve the experience for all users. You may disable cookies in your browser settings, though some features may not work as expected.</p>

        <h2>4. Data Retention</h2>
        <p>Anonymous quiz analytics may be retained indefinitely because they cannot be tied back to you. Saved plans, submitted events, feedback, and any associated email addresses are retained in our database until you request deletion.</p>

        <h2>5. Your Rights</h2>
        <p>You may request deletion of any personal data we hold about you, including saved plans and submitted email addresses. We will process deletion requests within 30 days.</p>

        <h2>6. Contact</h2>
        <p>Privacy questions may be directed to <a href="mailto:support@1uplift.com">support@1uplift.com</a>.</p>

        <p className="text-sm text-muted-foreground mt-8">© 2026 RanchPlanner. All rights reserved. Operated by 1uplift LLC.</p>
      </div>
    </div>
  );
}
